
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/arbitration",
      function () {
        return require("private-next-pages/[lang]/arbitration/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/arbitration"])
      });
    }
  